/**
 * Trygderett Module Description
 * Master Grade modul for trygderett
 */
import { MasterGradeBadge, ModuleSection, FeatureList, PrivacyNotice } from '../../shared';

export const TRYGDERETT_CONFIG = {
  id: 'trygderett',
  title: 'Trygderett',
  status: 'active',
  badge: 'Master',
  
  masterDescription: "er RettVerks mest avanserte nivå. Den kombinerer full faglig dekning innen trygderett med lokal AI-drevet vedtaksanalyse, automatisk fristberegning og generering av strukturerte klageutkast. Modulen er utviklet for å gi deg et helhetlig verktøy for å overprøve NAV-vedtak og sikre dine rettigheter i folketrygden.",
  
  aboutModule: "Trygderett-modulen gir deg verktøy for å klage på NAV-vedtak, forstå inngangsvilkår for ytelser og bygge en sterk sak med systematisk bevisinnhenting, basert på folketrygdloven og trygderettsloven.",
  
  features: [
    "Genererer strukturerte klager på NAV-vedtak med fokus på faktum og rettsanvendelse",
    "Formelt ankeskrift til Trygderetten med korrekte prosesskrav iht. trygderettsloven",
    "Sjekkliste for inngangsvilkår til AAP, uføretrygd og sykepenger (folketrygdloven)",
    "Beregner klagefristen (6 uker) automatisk basert på vedtaksdato",
    "Systematisk bevislagring for legeerklæringer og dialoglogger med saksbehandler"
  ],
  
  privacyText: "All analyse og behandling skjer lokalt på din enhet. NAV-vedtak og helseopplysninger lastes ikke opp, lagres ikke på servere og deles ikke med RettVerk."
};

export function TrygderettDescription() {
  const config = TRYGDERETT_CONFIG;
  
  return (
    <div className="space-y-5 max-h-[65vh] overflow-y-auto pr-2">
      <MasterGradeBadge description={config.masterDescription} />
      
      <ModuleSection icon="📋" title="Om modulen">
        <p className="text-sm text-[var(--text-muted)] leading-relaxed">
          {config.aboutModule}
        </p>
      </ModuleSection>
      
      <ModuleSection icon="⚙️" title="Funksjoner">
        <FeatureList features={config.features} />
      </ModuleSection>
      
      <PrivacyNotice text={config.privacyText} />
    </div>
  );
}

export default TrygderettDescription;
